import { useEffect, useRef, useState } from "react";
import { Modal } from "../components/ui";
import { useI18n } from "../i18n";
import { registerChallenge, type ChallengeRequest } from "./client";
import Verification from "./Verification";
export default function ChallengeDialog() {
  const { t } = useI18n();
  const [current, setCurrent] = useState<ChallengeRequest | null>(null);
  const pending = useRef<ChallengeRequest | null>(null);
  const cancel = () => {
    pending.current?.reject();
    pending.current = null;
    setCurrent(null);
  };
  useEffect(() => {
    const stop = registerChallenge((request) => {
      if (pending.current) {
        request.reject();
        return;
      }
      pending.current = request;
      setCurrent(request);
    });
    return () => {
      stop();
      pending.current?.reject();
    };
  }, []);
  return (
    <Modal
      open={!!current}
      onOpenChange={(open) => {
        if (!open) cancel();
      }}
      title={t("shield.verifyTitle")}
      description={t("shield.verifyInfo")}
    >
      {current && (
        <Verification
          key={current.challenge.id}
          challenge={current.challenge}
          onSolved={(pass) => {
            if (pending.current === current) {
              pending.current = null;
              current.resolve(pass);
              setCurrent(null);
            }
          }}
        />
      )}
      <button className="button" onClick={cancel}>
        {t("shield.verifyCancel")}
      </button>
    </Modal>
  );
}
